import { render } from "./GeoLocation.vue?vue&type=template&id=c45d28a8&scoped=true&ts=true"
import script from "./GeoLocation.vue?vue&type=script&lang=ts"
export * from "./GeoLocation.vue?vue&type=script&lang=ts"

import "./GeoLocation.vue?vue&type=style&index=0&id=c45d28a8&scoped=true&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c45d28a8"]])

export default __exports__